
import React from "react";

const Footer=(props)=>{

    return(
        <div className={"myFooterBox"}>
            <p>Powered by EASIPATH SOLUTIONS |
                <span className={"footerEmailLink"}>Email: Info@easipath.com</span> |
                <span className={"footerPhoneLink"}>Phone: + 27 87 313 25634</span> |
            </p>
        </div>
    )
}

export default Footer;